export default __webpack_public_path__ + "static/media/path4.35168509.svg";